import React from 'react';
import useSearchQuery from '@magoosh/utils/use_search_query';

import Preview from './preview';
import Profile from './profile';

interface Props {}

const ProfilePage: React.FC<Props> = (props) => {
  const preview = useSearchQuery()['preview'] === 'true';

  if (preview) {
    return <Preview />;
  } else {
    return <Profile />
  }
};

export default ProfilePage;
